const loadCookiePolicy = (window) => {
  const windowObject = window;
  windowObject.__CWT__ = typeof __CWT__ === 'object' ? __CWT__ : {};/* eslint-disable-line */

  if (!windowObject.__CWT__.cookiePolicyInstance) { /* eslint-disable-line */
    const body = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.src = '/assets/cookie-policy.js';
    script.async = true;
    body.appendChild(script);
  }
};

loadCookiePolicy(window);
